import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ImageBanner.css';

// Component
import ImageBannerForm from '../../../components/siteadmin/ImageBannerForm';
import Loader from '../../../components/Loader';
import { withQuery } from '../../../hoc/withGraphql';

const getDynamicInitialValues = (getImageBanner) => {
  if (!getImageBanner) return {};

  const { dynamicImageBanner, ...rest } = getImageBanner;

  let dynamicImageBannerValues = [];

  if (dynamicImageBanner && dynamicImageBanner.length > 0) {
    dynamicImageBannerValues = dynamicImageBanner.map(item => ({
      language: item.language || '',
      title: item.title || '',
      buttonLabel: item.buttonLabel || '',
      buttonLabel2: item.buttonLabel2 || '',
    }));
  } else {
    dynamicImageBannerValues = [{
      language: 'en',
      title: getImageBanner.title || '',
      buttonLabel: getImageBanner.buttonLabel || '',
      buttonLabel2: getImageBanner.buttonLabel2 || '',
    }];
  }

  return {
    ...rest,
    dynamicImageBanner: dynamicImageBannerValues
  };
};

const ImageBanner = (props) => {

  const { data: { loading, getImageBanner }, title } = props;

  if (loading) {
    return <Loader type={"text"} />;
  } else {
    const initialValues = getDynamicInitialValues(getImageBanner);
    return (
      <ImageBannerForm
        initialValues={initialValues}
        image={getImageBanner?.image}
        title={title}
      />
    );
  }
};

ImageBanner.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getImageBanner: PropTypes.object,
  })
};

ImageBanner.defaultProps = {
  data: {
    loading: true,
    image: null
  }
};

export default compose(
  withStyles(s),
  withQuery(gql`
    {
      getImageBanner {
        id
        title
        description
        buttonLabel
        image
        buttonLabel2
        buttonLink1
        buttonLink2
    dynamicImageBanner {
      id
      bannerId
      language
      title
      buttonLabel
      buttonLabel2
    }
      }
    }
  `, {
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }),
)(ImageBanner);